import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import {
  deleteWorkshopTestimonial,
  getWorkshopTestimonials,
} from "../../redux/services/workshopTestimonialSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const WorkshopTestimonial = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getTestimonialData = useSelector(
    (state) => state?.workshopTestimonial?.workshopTestimonialData
  );

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllTestimonials = useCallback(async () => {
    try {
      await dispatch(
        getWorkshopTestimonials({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllTestimonials();
  }, [getAllTestimonials]);

  const deleteTestimonial = async () => {
    try {
      const response = await dispatch(deleteWorkshopTestimonial(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllTestimonials();
    } catch (error) {}
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Name", key: "name" },
    { header: "Designation", key: "designation" },
    {
      header: "Description",
      key: "description",
      render: (description) => (
        <p className="line-clamp-2 text-foreground">{description}</p>
      ),
    },
    { header: "Rating", key: "rating" },
    {
      header: "Image",
      key: "image",
      render: (image) => (
        <img
          src={image}
          alt="testimonial"
          className="w-20 h-20 object-cover rounded-full"
        />
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WORKSHOPS.TESTIMONIALS_ADD_EDIT}?testimonialId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title="Workshop Testimonials"
        buttonTitle="Add Testimonial"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(ROUTES.WORKSHOPS.TESTIMONIALS_ADD_EDIT)}
        columns={columns}
        data={getTestimonialData?.webinar_testimonial_data || []}
        actions={actions}
        pageCount={getTestimonialData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Workshop Testimonial"
          confirm={confirm}
          onDelete={deleteTestimonial}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default WorkshopTestimonial;
